import { render } from "./ajax-error-toast.vue?vue&type=template&id=1f60e4a5"
import script from "./ajax-error-toast.vue?vue&type=script&lang=js"
export * from "./ajax-error-toast.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__